import { Box, Typography, Card, CardContent, CardMedia, Button } from '@mui/material';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { IDataProdutosPedidos } from '../../../../../../../../types/api/comercial/pedidos-pesquisar-produtos';
import { formatarValorMonetario } from '../../../../../../../../helpers/masks';
import { EstoqueChips } from './EstoqueChips';

export interface ProdutoCardProps {
    produto: IDataProdutosPedidos;
    handleAddClick: (produto: IDataProdutosPedidos) => void;
    publico_fazendeiro: boolean;
}

export function ProdutoCard({ produto, handleAddClick, publico_fazendeiro }: ProdutoCardProps) {
    return (
        <Card
            sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                elevation: 0,
                border: '1px solid #e0e0e0',
                boxShadow: 'none'
            }}
        >
            <CardMedia
                component="img"
                sx={{
                    height: 120,
                    objectFit: 'cover'
                }}
                image={produto.imagem?.url || "/imgs/imagem-invalida.png"}
                alt={produto.nome}
            />
            
            <CardContent
                sx={{
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    p: 2
                }}
            >
                <Typography gutterBottom variant="caption" color="text.secondary" component="div">
                    {produto.nome}
                </Typography>
                <Box>
                    <Box mb={1}>
                        <Typography variant="caption" color="text.secondary" display="block">
                            Preço base
                        </Typography>
                        <Typography variant="h6">
                            {formatarValorMonetario(produto.menor_preco)}
                        </Typography>

                        <EstoqueChips produto={produto} publico_fazendeiro={publico_fazendeiro} />
                    </Box>
                    <Button
                        variant="contained"
                        startIcon={<AddShoppingCartIcon />}
                        fullWidth
                        onClick={() => handleAddClick(produto)}
                        disabled={(produto.estoque_total === 0) || (produto.estoque[0]?.emite_receita === "S" && !publico_fazendeiro)}
                    >
                        ADICIONAR
                    </Button>
                </Box>
            </CardContent>
        </Card>
    );
}